import React, { useEffect } from "react";
import "./Event_Banner.css";
import Breadcrumb_Comp from "../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import White_Btn from "../../common/common_btn/white_btn/White_Btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UPcomingFestival } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";

const Event_Banner = () => {
  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    { label: "SHIBIR & EVENT REGISTRATIONS", link: "", active: true },
  ];



  const dispatch = useDispatch();

  const event = useSelector((state) => state.common.coming_festival);

  useEffect(() => {
    dispatch(UPcomingFestival());
  }, [dispatch])

  const navigate = useNavigate()

  if (!event) {
    return <></>
  }

  return (
    <section className="Event_Banner">
      <div className="container">
        <div className="main_content_div">
          <Breadcrumb_Comp data={breadcrumbs} />

          <Common_Title_1 subText="Shibir & Event Registrations" />

          <div className="banner_div">
            <div className="banner_holder">
              <img
                src={IDS.IMG_URL + event?.Event?.image}
                // src="/assets/images/event_registration/banner/banner.png"
                height="10px"
                className="bannr_img"
              />
            </div>

            <div className="footer_div">
              <div className="left_side">
                <p className="big_text">{event?.name || " "}</p>
                <p className="small_text">{event?.subname || " "}</p>
              </div>

              <div className="btn_holder">
                <White_Btn btnText={"Explore Now"} onClick={() => { navigate(`/shibir-registration/${encodeId(event?.event_id)}`) }} className="zoom_in_out" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Event_Banner;
